module.exports = __webpack_public_path__ + "static/img/20.c77b053.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/20.png
// module id = bUVn
// module chunks = 1